import bcrypt from "bcryptjs";

const PEPPER = process.env.REACT_APP_ENC;

export const hashing = async (password) => {
  return await bcrypt.hash(password + PEPPER, 10);
};

export const comparePass = async (str, hasing) => {
    return await bcrypt.compare(str, hasing);
}